<template>
<div class="midi-player hidden">
    <object id="Jazz1" classid="CLSID:1ACE1618-1C7D-4561-AEE1-34842AA85E90" class="hidden midi">
        <object id="Jazz2" type="audio/x-jazz" class="hidden midi">
            <p class="hidden">This page requires <a href=http://jazz-soft.net>Jazz-Plugin </a> ...</p> </object> </object> </div>
</template>

<script>

export default {
    name: "MidiPlayer",
    props: ["midi", "playMidi", "instrument", "reset", "velocity"],
    emits: ["finishedPlaying", "currentPosition"],
    data() {
        return {
            JZZ: null,
            smf: null,
            player: null,
            out: null,

            saved_midi: null,
            interval: null,

            playing: false,
            position: 0
        };
    },
    beforeUnmount(){
        if (this.playing && this.player) {
            this.playStop();
        }
    },
    watch: {
        midi(val, oldVal) {
            if (!val || val === oldVal) return;
            this.loadMidi(val);
            this.position = 0;
        },
        playMidi(val, oldVal) {
            if (val === oldVal) return;
            //console.log("HERE: ");
            this.playStop();
        },
        velocity(val, oldVal) {
            console.log(val);
            if (val === oldVal) return;
            this.changeVelocity();
        },
    },
    methods: {
        sendCurrentPosition() {
            if (this.player) {
                if (this.playing) {
                    this.$emit("currentPosition", this.player.position() / this.player.duration());
                } else {
                    this.$emit("currentPosition", 'Not Playing');
                }

            }
        },
        changeVelocity() {
            if (this.playing && this.player) {
                this.player.speed(this.velocity);
            }
        },
        loadMidi(midi) {
            //console.log("HERE MIDI LOAD 1");
            if (this.JZZ && midi && this.out) {
                if (this.playing && this.player) {
                    this.playing = false;
                    this.player.stop();
                }

                if (typeof midi === "string" || midi instanceof String) {
                    this.smf = new this.JZZ.MIDI.SMF(this.JZZ.lib.fromBase64(midi));
                    if (this.instrument) {
                        this.smf[1].program(0, this.JZZ.MIDI.programValue(this.instrument));
                    }
                } else if ('notes' in midi) {

                    this.smf = new this.JZZ.MIDI.SMF(0, 96);
                    let trk = new this.JZZ.MIDI.SMF.MTrk();

                    this.smf.push(trk);
                    trk.smfSeqName("This is a sequence name").smfBPM(midi['whole_duration']);

                    let start_time = 0;
                    for (let n in midi['notes']) {
                        let nn = midi['notes'][n];
                        if (nn[0] !== "R") {
                            trk
                                .ch(0)
                                .program(midi['instrument'])
                                .tick(start_time)
                                .note(nn[0].replace("-", "b"), 127, nn[1]);
                            start_time += nn[1];
                        } else {
                            start_time += nn[1];
                        }
                    }

                    trk.smfEndOfTrack();
                } else {
                    console.log('load_here');
                    this.smf = new this.JZZ.MIDI.SMF(0, 96);
                    let count = 0;

                    let trk = new this.JZZ.MIDI.SMF.MTrk();
                    this.smf.push(trk);
                    trk.smfBPM(midi['whole_duration']);

                    for (let track in midi.tracks) {

                        let loudness = midi.tracks[track]['loudness'];
                        if (midi.tracks[track]['is_muted']) {
                            loudness = 0;
                            console.log('Voice # ' + count + " - instrument: " + midi.tracks[track]['instrument'] + ' is muted!');
                        }

                        let channel = 0;
                        if (midi.tracks[track]['is_percussion'] === true) {
                            channel = 9;
                        } else {
                            console.log(midi.tracks[track]['instrument']);
                            trk.ch(channel).program(midi.tracks[track]['instrument']);
                        }
                        let start_time = 0;
                        for (let n in midi.tracks[track]['notes']) {
                            let nn = midi.tracks[track]['notes'][n];
                            let note = nn[0];
                            if (typeof note === 'string' || note instanceof String) {
                                note = note.replace("-", "b")
                            }
                            if (note !== "R") {
                                trk.add(
                                    start_time,
                                    this.JZZ.MIDI.noteOn(channel, note, Math.round(loudness * 127))
                                );
                                trk.add(
                                    start_time + nn[1],
                                    this.JZZ.MIDI.noteOff(channel, note, Math.round(loudness * 127))
                                );
                                start_time += nn[1];
                            } else {
                                start_time += nn[1];
                            }
                        }
                        count += 1;
                    }
                    trk.smfEndOfTrack();
                }

                this.player = this.smf.player();
                this.player.connect(this.out);
                this.saved_midi = midi;
            }
        },
        playStop() {
            if (!this.playing) {
                if (this.player) {
                    this.playing = true;
                    this.player.onEnd = () => {
                        this.playing = false;
                        this.position = 0;
                        this.$emit("finishedPlaying");
                        if (this.interval !== null) {
                            clearInterval(this.interval);
                        }
                    };

                    if (this.reset) {
                        this.position = 0;
                    }

                    this.player.jump(this.position);
                    this.interval = setInterval(() => this.sendCurrentPosition(), 120);
                    this.player.speed(this.velocity);
                    this.player.resume();
                }
            } else {
                if (this.player) {
                    this.playing = false;
                    this.position = this.player.position();
                    this.player.stop();
                    if (this.interval !== null) {
                        clearInterval(this.interval);
                    }
                }
            }
        },
    },
    mounted() {
        this.JZZ = require("jzz");
        require("jzz-midi-smf")(this.JZZ);

        require("jzz-synth-tiny")(this.JZZ);
        this.JZZ.synth.Tiny.register("Web Audio");

        require('jzz-midi-gm')(this.JZZ);

        this.JZZ.requestMIDIAccess({
            sysex: true,
        }).then(
            (access) => {
                console.log("access", access);
                console.log(
                    this.JZZ({
                        engine: ["webmidi"],
                        sysex: true,
                    }).info()
                );

                this.out = this.JZZ({
                        engine: ["webmidi"],
                        sysex: true,
                    })
                    .or("Cannot start MIDI engine!")
                    .openMidiOut()
                    .or("Cannot open MIDI Out!")
                    .and(function () {
                        console.log("MIDI-Out:", this.name());
                    });
            },
            (error) => console.log("error", error)
        );
        this.JZZ.close();
    },
};
</script>

<style>
.hidden {
    /* opacity: 0; */
    height: 6.8em;
    width: 3em;
    visibility: hidden;
    /* display: none; */
}

.midi-player, .midi {
    position: absolute;
    top: 0;
    left: 0;
}

body > object {

}
</style>
